import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";

export default function Collaboration() {
    const { t } = useLang();

    // All entities for a seamless loop (doubled to allow -50% translate)
    const all = [t.collaboration.lead, ...t.collaboration.partners];
    const loop = [...all, ...all, ...all, ...all];

    return (
        <section
            id="collaboration"
            className="relative py-20 sm:py-24 md:py-28 border-t border-[color:var(--sau-border)] overflow-hidden"
            data-testid="sau-collaboration"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="text-center max-w-3xl mx-auto">
                    <SectionHeading align="center" eyebrow={t.collaboration.eyebrow} title={t.collaboration.title} />
                    <p className="sau-reveal mt-5 sm:mt-6 text-[15px] sm:text-base text-[color:var(--sau-text-2)] leading-relaxed">
                        {t.collaboration.intro}
                    </p>
                </div>

                <div className="sau-reveal mt-8 sm:mt-10 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm">
                    <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[color:var(--sau-muted)]">
                        {t.collaboration.leadLabel}
                    </div>
                    <div className="inline-flex items-center gap-2 px-4 h-10 rounded-full border border-[color:var(--sau-border)] bg-[#0B1A2B]">
                        <span className="sau-badge-dot" />
                        <span className="text-sm font-medium text-[color:var(--sau-text)]">
                            {t.collaboration.lead}
                        </span>
                    </div>
                </div>
            </div>

            <div className="mt-12">
                <div className="text-center text-[11px] uppercase tracking-[0.28em] text-[color:var(--sau-muted)] mb-6">
                    {t.collaboration.withLabel}
                </div>
                <div className="sau-marquee" role="region" aria-label="Collaborating institutions">
                    <div className="sau-marquee-track">
                        {loop.map((name, i) => (
                            <div key={`${name}-${i}`} className="flex items-center gap-6 sm:gap-10 flex-shrink-0">
                                <span className="text-[15px] sm:text-base md:text-lg font-medium text-[color:var(--sau-text-2)] whitespace-nowrap opacity-80 hover:opacity-100 transition-opacity">
                                    {name}
                                </span>
                                <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--sau-border)]" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
